import { z } from 'zod';
export const citySchema = z.string().meta({ autocomplete: 'address-level2' });
